// extracted by mini-css-extract-plugin
export default {"button":"UploadFileButton_button__dhLFQ","icon":"UploadFileButton_icon__4wp3v"};